import { render, staticRenderFns } from "./Secundaria.vue?vue&type=template&id=3f2903a3&scoped=true"
import script from "./Secundaria.vue?vue&type=script&lang=js"
export * from "./Secundaria.vue?vue&type=script&lang=js"
import style0 from "./Secundaria.vue?vue&type=style&index=0&id=3f2903a3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f2903a3",
  null
  
)

export default component.exports